import { render, staticRenderFns } from "./DataApplicationCustomerSubForm.vue?vue&type=template&id=be06ad46"
import script from "./DataApplicationCustomerSubForm.vue?vue&type=script&lang=js"
export * from "./DataApplicationCustomerSubForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports